﻿import { createApp } from 'vue';

export default class CheckoutForm {
    constructor() {
        this.clickedSubmitForm = this.clickedSubmitForm.bind(this);

        this.setup();
    }

    setup() {
        const componentClass = '.checkout-form';
        const component = document.querySelector(componentClass);

        if (component) {
            this._invalidMessage = 'Kolla att alla fält blev rätt ifyllda!';

            const checkoutForm = {
                data() {
                    return {
                        statusMessage: '',
                        pending: false,
                        success: false,
                        name: {
                            value: '',
                            invalid: false,
                            errorMessage: 'Du måste ange ditt namn',
                            id: 'error-name'
                        },
                        organization: {
                            value: '',
                            invalid: false
                        },
                        deliveryAddress: {
                            value: '',
                            invalid: false,
                            errorMessage: 'Du måste ange leveransadress',
                            id: 'error-address'
                        },
                        zipCode: {
                            value: '',
                            invalid: false,
                            errorMessage: 'Du måste ange ditt postnummer',
                            id: 'error-zipcode'
                        },
                        city: {
                            value: '',
                            invalid: false,
                            errorMessage: 'Du måste ange ort',
                            id: 'error-city'
                        },
                        email: {
                            value: '',
                            invalid: false,
                            errorMessage: 'Du måste ange en giltig e-postadress',
                            id: 'error-email'
                        },
                        phone: {
                            value: '',
                            invalid: false
                        },
                        billingAddress: {
                            value: '',
                            invalid: false
                        },
                        approval: {
                            value: false,
                            invalid: false,
                            errorMessage: 'Du måste godkänna villkoren',
                            id: 'error-approval'
                        },
                    }
                },
                mounted() {
                    this.name.value = this.$refs.name ? this.$refs.name.dataset.value : '';
                    this.organization.value = this.$refs.organization ? this.$refs.organization.dataset.value : '';
                    this.deliveryAddress.value = this.$refs.deliveryAddress ? this.$refs.deliveryAddress.dataset.value : '';
                    this.zipCode.value = this.$refs.zipCode ? this.$refs.zipCode.dataset.value : '';
                    this.city.value = this.$refs.city ? this.$refs.city.dataset.value : '';
                    this.email.value = this.$refs.email ? this.$refs.email.dataset.value : '';
                    this.phone.value = this.$refs.phone ? this.$refs.phone.dataset.value : '';
                    this.billingAddress.value = this.$refs.billingAddress ? this.$refs.billingAddress.dataset.value : '';
                },
                methods: {
                    submitForm: this.clickedSubmitForm
                }
            };

            this._component = createApp(checkoutForm).mount(componentClass);
       }
    }

    /**
     * Click submit handler.
     * @param {Object} e Event object
     */
    clickedSubmitForm(e) {

        this.setStatus('');

        const validFields = [
            this.validate(this._component.name),
            this.validate(this._component.deliveryAddress),
            this.validate(this._component.zipCode),
            this.validate(this._component.city),
            this.validate(this._component.email),
            this.validate(this._component.approval),
            this.validEmail(this._component.email)
        ];

        if (validFields.every(valid => valid)) {
            return true; //Submit form
        } else {
            e.preventDefault();
            this.setStatus('Ett fel uppstod. Kontrollera att alla uppgifter är rätt ifyllda!');

            return false;
        }
    }

    /**
    * Set a status message
    * @param {String} message 
    */
    setStatus(message) {
        this._component.statusMessage = message;
    }

    /**
    * Validate a field.
    * @param {Object} field Field object from Vue component
    */
    validate(field) {
        field.invalid = !field.value;
        return !field.invalid;
    }

    validEmail(field) {
        var re = /\S+@\S+\.\S+/;
        field.invalid = !re.test(field.value);

        return !field.invalid;
    }
}